// Effets d'écran des scènes (jeu et aperçu de l'admin) : fondu au noir et retour, tremblement, flash, par-dessus la carte.
import type { ScreenEffect } from '../../shared/scenes.ts';

export class ScreenEffects {
  private readonly veil: HTMLElement;
  private readonly shaken: HTMLElement;
  private shaking: Animation | null = null;

  /** `host` : où poser le voile (au-dessus de la carte) ; `shaken` : ce qui tremble. */
  constructor(host: HTMLElement, shaken: HTMLElement) {
    this.shaken = shaken;
    // Un seul voile par endroit, même si l'on recrée l'objet (nouvelle connexion au jeu).
    this.veil = host.querySelector<HTMLElement>(':scope > .screen-fx') ?? host.appendChild(Object.assign(document.createElement('div'), { className: 'screen-fx' }));
    Object.assign(this.veil.style, { position: 'absolute', inset: '0', pointerEvents: 'none', opacity: '0', background: '#000', zIndex: '5' });
  }

  apply(effect: ScreenEffect | 'clear', ms: number): void {
    const duration = `${Math.max(0, ms)}ms`;
    switch (effect) {
      case 'fade-out':
        this.fade('#000', '1', duration);
        return;
      case 'fade-in':
        this.fade('#000', '0', duration);
        return;
      case 'flash':
        // Blanc d'un coup, puis il s'efface.
        this.fade('#fff', '0.9', '0ms');
        requestAnimationFrame(() => this.fade('#fff', '0', duration));
        return;
      case 'shake':
        this.shaking?.cancel();
        this.shaking = this.shaken.animate(
          [0, -6, 6, -4, 4, -2, 2, 0].map((x, index) => ({ transform: `translate(${x}px, ${index % 2 ? 3 : -3}px)` })),
          { duration: Math.max(1, ms), easing: 'linear' },
        );
        return;
      case 'clear':
        this.shaking?.cancel();
        this.fade('#000', '0', '0ms');
    }
  }

  private fade(color: string, opacity: string, duration: string): void {
    Object.assign(this.veil.style, { background: color, transition: `opacity ${duration} linear`, opacity });
  }
}
